import React, { memo, useCallback, useState } from 'react';
import { Avatar, Button, Icon, Typography } from '@ann/web-components';
import { WIDGET_LIBRARY_COPY } from '../../../../constants/dashboardBuilderCopy';
import WidgetPreviewRenderer from '../WidgetPreviewRenderer';
import {
  AboutCard,
  AboutCardText,
  BestForCard,
  BestForCardContent,
  Container,
  DetailContent,
  DetailFooter,
  DetailHeader,
  DetailHeaderLeft,
  PreviewArea,
  PreviewHeader,
  PreviewSection,
  SizeButtonGroup,
} from './WidgetDetailView.styled';

const SIZES = ['small', 'medium', 'large'];

const WidgetDetailView = ({ widget, onBack, onClose, onAdd }) => {
  const [selectedSize, setSelectedSize] = useState('large');

  const handleAdd = useCallback(() => {
    onAdd?.(widget, selectedSize);
  }, [onAdd, widget, selectedSize]);

  return (
    <Container>
      <DetailHeader>
        <DetailHeaderLeft>
          <Button
            type="tertiary"
            size="medium"
            iconLeft="arrowLeft"
            onClick={onBack}
          />
          {widget.previewImage ? (
            <Avatar size="sm" src={widget.previewImage} alt={widget.name || 'Widget'} />
          ) : (
            <Icon name={widget.icon} size="small" />
          )}
          <Typography category="subtitle" size="medium" weight="bold">
            {widget.name}
          </Typography>
        </DetailHeaderLeft>
        <Button
          type="tertiary"
          size="small"
          iconLeft="close"
          onClick={onClose}
        />
      </DetailHeader>

      <DetailContent>
        <AboutCard>
          <AboutCardText>
            <Typography category="subtitle" size="small" weight="bold">
              {WIDGET_LIBRARY_COPY.widgetDetailAboutTitle}
            </Typography>
            <Typography category="body" size="medium" weight="regular" color="secondary">
              {widget.description}
            </Typography>
          </AboutCardText>
          <Icon materialName="widgets" color="primary-alt"  name=""   size="medium"
          />
        </AboutCard>

        <BestForCard>
          <Icon name="info" size="medium" />
          <BestForCardContent>
            <Typography category="subtitle" size="small" weight="bold">
              {WIDGET_LIBRARY_COPY.widgetDetailBestForTitle}
            </Typography>
            <Typography category="body" size="medium" weight="regular">
              {widget.description}
            </Typography>
          </BestForCardContent>
        </BestForCard>

        <PreviewSection>
          <PreviewHeader>
            <Typography category="subtitle" size="small" weight="bold">
              {WIDGET_LIBRARY_COPY.widgetDetailPreviewLabel}
            </Typography>
            <SizeButtonGroup>
              {SIZES.map((size) => (
                <Button
                  key={size}
                  type={selectedSize === size ? 'primary' : 'secondary'}
                  size="small"
                  label={size.charAt(0).toUpperCase() + size.slice(1)}
                  onClick={() => setSelectedSize(size)}
                />
              ))}
            </SizeButtonGroup>
          </PreviewHeader>
          <PreviewArea>
            <WidgetPreviewRenderer widget={widget} mode="full" selectedSize={selectedSize} />
          </PreviewArea>
        </PreviewSection>
      </DetailContent>

      <DetailFooter>
        <Button
          type="primary"
          size="medium"
          label={WIDGET_LIBRARY_COPY.widgetDetailAddButton}
          onClick={handleAdd}
        />
      </DetailFooter>
    </Container>
  );
};

export default memo(WidgetDetailView);
